<div class="public-phone">
  <ziro-top-nav></ziro-top-nav>
  @if (!isLoading) {
    <div class="row public-phone__window">
      <div class="col-lg-2 col-md-3">
        <ziro-public-phone-contact-card></ziro-public-phone-contact-card>
        @if (phoneId) {
          <ziro-public-phone-operations-menu
            [phoneId]="phoneId"
            [isCopyPhoneButtonEnabled]="isCopyPhoneButtonEnabled"
            [isUnsavedCopy]="isUnsavedCopy"
            class="mt-4"
          ></ziro-public-phone-operations-menu>
        }
      </div>
      <div class="col-lg-10 col-md-9 public-phone__window__main" data-automation="public-phone">
        <ziro-breadcrumbs></ziro-breadcrumbs>
        <router-outlet></router-outlet>
      </div>
    </div>
  }
  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  }
  <div class="row">
    <ziro-bottom-nav class="w-100"></ziro-bottom-nav>
  </div>
</div>
